import { z } from 'zod';

export const GatewayZod = z.union([
  z.literal('cryptomus'),
  // z.literal('payselection'),
  z.literal('stripe'),
]);
export type GatewayType = z.infer<typeof GatewayZod>;
/**
 * Currently,
 * - only one proxy type
 * - only increase traffic
 * -
 *
 */
export const OrderZod = z.object({
  id: z.string(),
  gateway: GatewayZod,
  amount: z.string().min(1),
  mobileGb: z.number(),
  residentialGb: z.number(),
  datacenterGb: z.number(),
  recurrent: z.boolean()
});
export type OrderType = z.infer<typeof OrderZod>;

//export const CreateOrderZod = OrderZod.omit({amount: true}); --> Doesn't work
export const CreateOrderZod = z.object({
  id: z.string().optional(),
  gateway: GatewayZod,
  mobileGb: z.number(),
  residentialGb: z.number(),
  datacenterGb: z.number(),
  recurrent: z.boolean(),
  promocode: z.string().optional(),
  gclid: z.string().optional(),
  utm_source: z.string().optional(),
  utm_campaign: z.string().optional(),
  utm_medium: z.string().optional(),
  posthog_sid: z.string().optional(),
});
export type CreateOrderType = z.infer<typeof CreateOrderZod>;